import styled from '@emotion/styled';
import { COLORS3 as COLORS, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const ContactSectionWrapper = styled.div`
  border-bottom: 1px solid ${COLORS.BLACK_030};
  padding: 56px ${SPACING.S24};
  text-align: left;

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    margin: 0 auto;
    padding: 64px 0;
    text-align: center;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin: 0 auto;
    padding: 72px 0;
  }
`;

export const TitleWrapper = styled.div`
  h2 {
    font-size: ${FONT.FONT_SIZE_LARGER};
    line-height: 100%;

    ${MEDIA_QUERY.DESKTOP} {
      font-size: ${FONT.FONT_SIZE_SEMI_HUGE};
    }

    ${MEDIA_QUERY.DESKTOP_XL} {
      font-size: 64px;
    }
  }
`;

export const Information = styled.p`
  font-size: ${FONT.FONT_SIZE_SMALLER};
  line-height: ${FONT.FONT_SIZE_REGULAR};
  margin: ${SPACING.XS} 0 ${SPACING.S16} 0;

  ${MEDIA_QUERY.MOBILE} {
    br {
      display: none;
    }
  }

  ${MEDIA_QUERY.TABLET} {
    font-size: 18px;
    line-height: ${FONT.FONT_SIZE_LARGE};
    margin: ${SPACING.S16} 0 ${SPACING.S24} 0;
  }

  ${MEDIA_QUERY.DESKTOP} {
    font-size: ${FONT.FONT_SIZE_REGULAR};
    line-height: ${FONT.FONT_SIZE_LARGER};
    margin: ${SPACING.S16} 0 ${SPACING.S24} 0;
  }

  ${MEDIA_QUERY.DESKTOP_XL} {
    margin: ${SPACING.S24} 0 ${SPACING.S32} 0;
  }
`;
